export function apiItems(data, preferredKeys = []) {
  if (!data || typeof data !== 'object') return []
  if (Array.isArray(data)) return data
  for (const key of preferredKeys) {
    if (Array.isArray(data[key])) return apiItems(data[key], preferredKeys)
  }
  for (const key of ['data', 'items', 'rows', 'result', 'results', 'users', 'pccs', 'scripts', 'customScripts']) {
    if (Array.isArray(data[key])) return apiItems(data[key], preferredKeys)
  }
  if (data.username || data.pcc || data.uuid) return [data]
  return []
}

export function normalizeAgency(agency) {
  const plan = agency?.paymentPlan || agency?.payment_plan || null
  return {
    uuid_payment_plan: String(agency?.uuidPaymentPlan || agency?.uuid_payment_plan || ''),
    name: String(agency?.name || ''),
    description: String(agency?.description || ''),
    parent_pcc: String(agency?.parentPcc || agency?.parent_pcc || '').toUpperCase(),
    status: String(agency?.status ?? '0'),
    created_date: agency?.created_date || agency?.createdDate || null,
    updated_date: agency?.updated_date || agency?.updatedDate || null,
    payment_plan: plan && typeof plan === 'object' ? {
      uuid: String(plan.UUID || plan.uuid || ''),
      price: Number(plan.price || 0),
      users: Number(plan.users || 0),
      custom_scripts: Number(plan.customScripts || plan.custom_scripts || 0),
      boston_scripts: Number(plan.bostonScripts || plan.boston_scripts || 0),
      typeof: String(plan.typeof || plan.type_of || ''),
    } : null,
  }
}

export function normalizeScript(script) {
  return {
    uuid: String(script?.uuid || script?.UUID || script?.id || '').toLowerCase(),
    name: String(script?.name || script?.namescript || script?.scriptName || script?.title || 'Script'),
    description: String(script?.description || script?.desc || ''),
    url: String(script?.url || script?.link || ''),
    username: String(script?.username || ''),
    parent_pcc: String(script?.parent_pcc || script?.parentPcc || script?.parentPCC || ''),
    pcc: String(script?.pcc || script?.PCC || script?.pcc_code || ''),
    status: Number(script?.status ?? 1),
    keywords: ['undefined', 'null'].includes(String(script?.keywords || script?.tags || '').trim().toLowerCase())
      ? ''
      : String(script?.keywords || script?.tags || ''),
    config: typeof script?.config === 'string'
      ? script.config
      : JSON.stringify(script?.config || {}, null, 2),
    config_template: typeof script?.config_template === 'string'
      ? script.config_template
      : typeof script?.configTemplate === 'string'
        ? script.configTemplate
        : JSON.stringify(script?.config_template || script?.configTemplate || {}, null, 2),
    apply_config: String(script?.apply_config || '0'),
    foundinpcc: Number(script?.foundinpcc || 0),
    created_date: script?.created_date || script?.createdDate || script?.created || null,
    updated_date: script?.updated_date || script?.updatedDate || script?.updated || null,
  }
}

export function monitorToken(session) {
  return String(
    session?.token
    || session?.sabreToken
    || session?.sabre_token
    || session?.sessionToken
    || session?.session_token
    || session?.permission
    || session?.Permission
    || session?.access_token
    || '',
  )
}

export function normalizeMonitor(session) {
  const token = monitorToken(session)
  return {
    username: String(session?.username || session?.user || session?.usuario || ''),
    parent_pcc: String(session?.parent_pcc || session?.parentPcc || session?.parentPCC || '').toUpperCase(),
    pcc: String(session?.pcc || session?.PCC || session?.pcc_code || '').toUpperCase(),
    name: String(session?.name || session?.nombre || ''),
    created: session?.created && session.created !== '0000-00-00 00:00:00' ? session.created : null,
    updated: session?.updated && session.updated !== '0000-00-00 00:00:00' ? session.updated : null,
    has_token: token !== '',
    is_sabre: token.startsWith('ATH:'),
    token,
    token_length: token.length,
  }
}
